class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

   displayDropdown() {
    const toggleBtn = document.querySelector('.cart-drawer-warranty-toggle');
    const warrantyContent = document.querySelector('.cart-drawer-warranty-content');

    if (toggleBtn && warrantyContent) {
        warrantyContent.style.display = 'flex'; // Ensure layout, hidden by max-height
        toggleBtn.addEventListener('click', function() {
            toggleBtn.classList.toggle('active');
            warrantyContent.classList.toggle('active');
        });
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




class WarrantyItem extends HTMLElement {
  constructor() {
    super();

    const toggleBtn = this.querySelector('.cart-drawer-2-warranty-toggle');
    const warrantyContents = this.querySelector('.cart-drawer-2-warranty-content');
        
    if (toggleBtn && warrantyContents) {
        warrantyContents.style.display = 'flex';
        toggleBtn.addEventListener('click', function() {
            toggleBtn.classList.toggle('active');
            warrantyContents.classList.toggle('active');
        });
    }

    const button = this.querySelector('.custom-atc-card-drawer-2');

    const variant_id = button.getAttribute('data-variant-id');

    const variant_quantity = button.getAttribute('data-variant-quantity');

    const key = button.getAttribute('data-key');

    const unique_key = button.getAttribute('data-unique-key');

    button.addEventListener("click", (e) => {
    e.preventDefault();
    button.setAttribute('disabled', '');
    button.querySelector('.loading__spinner').classList.remove('hidden');
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
        },
        body: JSON.stringify({
        id: variant_id,
        quantity: variant_quantity,
        properties: {
            "_Random_ID": `${unique_key}`
        },
        parent_line_key: `${key}`
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('✅ Item added to cart:', data);

        // ---- Now update a specific property for this cart item ----
        const itemKey = `${key}`; // The unique cart item key returned by Shopify
        const propertyName = '_Random_ID'; // Change this to your desired property name
        const propertyValue = `${unique_key}`; // Change this to your desired value

        // Fetch the cart and update the specific item's property
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const item = cart.items.find(i => i.key === itemKey);
            if (!item) {
            console.error('❌ Item not found in cart:', itemKey);
            return;
            }

            // Clone existing properties and update the specific one
            const updatedProperties = { ...item.properties, [propertyName]: propertyValue };

            // Send update request
            return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: itemKey,
                quantity: item.quantity,
                properties: updatedProperties
            })
            });
        })
        .then(response => response?.json())
        .then(updatedCart => {
            if (updatedCart) {
            console.log('🛒 Cart item property updated successfully:', updatedCart);
            // Optional: refresh cart drawer or update UI here

              setTimeout(() => {
            fetch(`${routes.cart_url}?sections=cart-drawer`)
              .then(response => response.json())
              .then(sections => {
                const sectionId = 'cart-drawer';
                const htmlString = sections[sectionId];
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                const sourceElement = html.querySelector(sectionId);
                const targetElement = document.querySelector(sectionId);

                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }

                document.body.classList.add('overflow-hidden');
                const theme_cart =
                  document.querySelector('cart-notification') ||
                  document.querySelector('cart-drawer');
                if (theme_cart && theme_cart.classList.contains('is-empty'))
                  theme_cart.classList.remove('is-empty');
                theme_cart.classList.add('active');

                button.removeAttribute('disabled', '');
                button.querySelector('.loading__spinner').classList.add('hidden');
              })
              .catch(e => console.error('Error updating cart sections:', e));
          }, 20); 
            }
        })
        .catch(error => console.error('Error updating cart item property:', error));
    })
    .catch(error => {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
    });
    });

    
  }
}

customElements.define('warranty-item', WarrantyItem);

